// Layout constants
export const POSTBOX_INITIAL_VISIBLE = 10;
export const POSTBOX_LOAD_MORE_COUNT = 10;
export const POSTBOX_NULL_FORCE_COUNT = 5;
export const POSTBOX_NULL_RANDOM_CHANCE = 0.25;

// Train constants
export const TRAIN_EMPTY_CHANCE = 0.2;

// Blog constants
export const BLOG_POSTS_PER_PAGE = 8;
export const REVIEW_POSTS_PER_PAGE = 4;
export const BLOG_PREVIEW_MAX_LENGTH = 500;

// Sound constants
export const SOUND_POSTS_PER_PAGE = 5;

// Music constants
export const MUSIC_STAT_LIMIT = 5;
export const MUSIC_STAT_TIME_RANGE = 'short_term';

// Spotify constants
export const SPOTIFY_REFRESH_INTERVAL = 5000;
export const SPOTIFY_PROGRESS_UPDATE_INTERVAL = 50;
export const SPOTIFY_NEW_TRACK_CHECK_DELAY = 500;
export const SPOTIFY_WAVE_BAR_COUNT = 9;

